import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { HttpStatusCode } from 'axios';
import { ERROR_CODE_MESSAGE } from 'src/utils/constants/statusCode';
import { useFeatureRestrictionStore } from 'src/zustand/useFeatureRestrictionStore';
import { NotifyType, useNotifyCreditCosts } from 'src/zustand/useNotifyCreditCosts';

const onError = (error: ExpectedAny, query: ExpectedAny) => {
  const responseData = error?.response?.data;
  if (
    responseData?.status_code === HttpStatusCode.BadRequest &&
    [
      ERROR_CODE_MESSAGE.FEATURE_NOT_FOUND,
      ERROR_CODE_MESSAGE.FEATURE_TYPE_NOT_FOUND,
      ERROR_CODE_MESSAGE.ENDPOINT_NOT_FOUND,
    ].includes(responseData?.error?.code || '')
  ) {
    useFeatureRestrictionStore.getState().handleOpen();
  }

  if (!query?.meta?.ignoreError) {
    console.error(error.message);
  }
};

const queryCache: ExpectedAny = new QueryCache({
  onError,
});

const mutationCache: ExpectedAny = new MutationCache({
  onError,
});

export const queryClient: QueryClient = new QueryClient({
  queryCache,
  mutationCache,
});
